import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "content"]
  static values = { defaultTab: String }

  connect() {
    // Activate default tab if specified
    if (this.hasDefaultTabValue && this.defaultTabValue) {
      this.activateTab(this.defaultTabValue)
    }
  }

  switch(event) {
    const tabName = event.params.tab
    this.activateTab(tabName)
  }

  activateTab(tabName) {
    // Hide all content
    this.contentTargets.forEach(content => {
      content.classList.add("hidden")
    })

    // Reset all tab buttons
    this.tabTargets.forEach(tab => {
      tab.classList.remove("border-fitcloud-coral", "text-fitcloud-coral")
      tab.classList.add("border-transparent", "text-gray-500")
    })

    // Show selected content
    const selectedContent = this.contentTargets.find(
      content => content.dataset.tabsTab === tabName
    )
    if (selectedContent) {
      selectedContent.classList.remove("hidden")
    }

    // Highlight selected tab
    const selectedTab = this.tabTargets.find(
      tab => tab.dataset.tabsTabParam === tabName
    )
    if (selectedTab) {
      selectedTab.classList.remove("border-transparent", "text-gray-500")
      selectedTab.classList.add("border-fitcloud-coral", "text-fitcloud-coral")
    }
  }
}
